<template lang="pug">
	div
		Nueva(v-if="crear", @cerrar="crear = null")
		router-view
</template>

<script>
import Nueva from './components/nueva/nueva.component'

export default {
	components: {
		Nueva
	},
	data () {
		return {
			crear: null
		}
	},
	created () {
		const menu = [
			{
				'icono': 'fa fa-list',
				'nombre': 'Listado',
				activo: true,
				callback: (a) => {
					this.$store.commit('top/setMenuActivo', a)
					this.$router.push('/main/produccion-audiovisual')
					// this.seccion = 'listado'
				}
			},
			{
				'icono': 'fa fa-search',
				'nombre': 'Buscador',
				activo: false,
				callback: (a) => {
					this.$store.commit('top/setMenuActivo', a)
					this.$router.push('/main/produccion-audiovisual/buscador')
					// this.seccion = 'buscador'
				}
			}]

		this.$store.commit('top/setMenu', menu)
	}
}
</script>



// WEBPACK FOOTER //
// src/modulos/produccion-audiovisual/vue/main.component.vue